import * as React from 'react'
import { IInvoice, CreateInvoice, API, TaxGroup } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { message } from 'antd'
import { browserHistory } from 'react-router'
import { Routes } from '../../../../../constants/Routes'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'

interface Props {
  title: string
  widthBreakPoint?: number
  createInvoice: CreateInvoiceDetail
  getInvoiceTaxGroup: (invoiceDetail: IInvoice) => TaxGroup | undefined
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const DuplicateButton = inject('currentCompanyStore')(
  observer((props: Props & InjectedProps) => {
    const { title, widthBreakPoint, createInvoice, getInvoiceTaxGroup, currentCompanyStore } = props
    const { invoiceDetail } = createInvoice

    if (!invoiceDetail) {
      return null
    }

    const companyId = currentCompanyStore!.company!.id

    const createDuplicate = () => {
      const newInvoice = new CreateInvoice()

      newInvoice.populate({
        ...invoiceDetail,
        orderDate: null,
        completeDate: null,
        paymentDueDate: null,
        paid: 0,
      })

      newInvoice.lines.forEach((line) => {
        line.quantityReceived = 0
        line.id = null
      })

      if (invoiceDetail.taxGroupId) {
        const matchingTaxGroup = getInvoiceTaxGroup(invoiceDetail)

        if (matchingTaxGroup) {
          newInvoice.setTaxGroup(matchingTaxGroup)
        }
      }

      newInvoice.title = `${invoiceDetail.title} (duplicate)`

      return newInvoice
    }

    const duplicate = async () => {
      if (!window.confirm('Create a duplicate of this purchase order?')) {
        return
      }

      try {
        const duplicateInvoice = createDuplicate()

        await API.createInvoice(companyId, duplicateInvoice.getNetworkObject())

        createInvoice.setIsSaved(true)

        browserHistory.push(Routes.DASHBOARD_INVOICES(companyId))

        message.success(`Purchase order successfully duplicated`)
      } catch (error) {
        message.error(`There was an error duplicating this purchase order`)
      }
    }

    return (
      <BlazeButton
        buttonProps={{
          onClick: duplicate,
          icon: 'copy',
        }}
        titleProps={{
          title,
          widthBreakPoint,
        }}
      />
    )
  }),
)
